<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-autocomplete
                        v-model="selectedLcId"
                        :items="lcList"
                        :item-title="item => `${item.lc_no} - ${item.code || ''}`"
                        item-value="id"
                        label="Filter by LC"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        clearable
                        hide-details
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                GRN Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goToCreate"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create GRN
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="filteredGnrList"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.gnr_date="{ item }">
                    {{ formatDate(item.gnr_date) }}
                  </template>

                  <template v-slot:item.lc_id="{ item }">
                    {{ item.lc?.lc_no || item.lc_id }}
                  </template>

                  <template v-slot:item.shipment_id="{ item }">
                    {{ item.shipment?.shipment_no || item.shipment_id }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status === 1 ? 'success' : 'grey'"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.status === 1 ? 'Posted' : 'Draft' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewGnr(item.id)"
                    ></v-btn>
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      @click="editGnr(item.id)"
                      v-if="item.status === 0"
                    ></v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formatDateView from "@/plugins/dateFormatView";
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useForm, useField } from "vee-validate";

export default {
  name: "LcImportGnrRecord",
  data: () => ({
    panel: [0],
    panel1: [0],
  }),
  setup() {
    const store = useStore();
    const router = useRouter();

    const loading = ref(false);
    const search = ref("");
    const selectedLcId = ref(null);

    const { handleSubmit } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");

    const headers = [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "GRN No", key: "gnr_no", align: "left", sortable: true },
      { title: "GRN Date", key: "gnr_date", align: "left", sortable: true },
      { title: "LC No", key: "lc_id", align: "left", sortable: true },
      { title: "Shipment No", key: "shipment_id", align: "left", sortable: true },
      { title: "Status", key: "status", align: "center", sortable: true },
      { title: "Actions", key: "actions", sortable: false, align: "center", width: "10%" },
    ];

    const getLcImportGnrList = computed(() => {
      return store.getters["getLcImportGnrList"] || [];
    });

    const lcList = computed(() => {
      return store.getters.getLcImportLcMasterList || [];
    });

    const filteredGnrList = computed(() => {
      let filtered = [...getLcImportGnrList.value];

      if (selectedLcId.value) {
        filtered = filtered.filter(item => item.lc_id === selectedLcId.value);
      }

      if (from_date.value.value && to_date.value.value) {
        filtered = filtered.filter(item => {
          const itemDate = new Date(item.gnr_date);
          return itemDate >= new Date(from_date.value.value) && itemDate <= new Date(to_date.value.value);
        });
      }

      return filtered;
    });

    const formatDate = (date) => {
      if (!date) return "";
      return formatDateView(date);
    };

    const loadGnrList = async () => {
      loading.value = true;
      try {
        await store.dispatch("getLcImportGnrList");
      } catch (error) {
        toast.error("Failed to load GRN records");
      } finally {
        loading.value = false;
      }
    };

    const submit = handleSubmit(async (values) => {
      await loadGnrList();
    });

    const goToCreate = () => {
      router.push({ name: "lc-import-gnr-create" });
    };

    const viewGnr = (id) => {
      router.push({ name: "lc-import-gnr-view", params: { id } });
    };

    const editGnr = (id) => {
      router.push({ name: "lc-import-gnr-edit", params: { id } });
    };

    const exportToCSV = () => {
      toast.info("CSV export feature coming soon");
    };

    const exportToExcel = () => {
      toast.info("Excel export feature coming soon");
    };

    const exportToPDF = () => {
      toast.info("PDF export feature coming soon");
    };

    onMounted(async () => {
      await loadGnrList();
      if (store.getters.getLcImportLcMasterList.length === 0) {
        await store.dispatch("getLcImportLcMasterList");
      }
    });

    return {
      loading,
      search,
      selectedLcId,
      from_date,
      to_date,
      headers,
      getLcImportGnrList,
      lcList,
      filteredGnrList,
      formatDate,
      loadGnrList,
      submit,
      goToCreate,
      viewGnr,
      editGnr,
      exportToCSV,
      exportToExcel,
      exportToPDF,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

